import Header from "./Header.jsx";
import PageMenu from "./PageMenu.jsx";
import Footer from "./PageFooter_temporary.jsx";
import FlowFromInquiry from "./FlowFromInquiry.jsx";
import AboutDemolitionWork from "./AboutDemolitionWorkPage.jsx";
import ReasonForChoosing from "./ReasonForChoosing.jsx";
import Exterior from "./Exterior.jsx";
import Profile from "./Profile.jsx";
import Company from "./Company.jsx";
import Recruit from "./Recruit.jsx";
import Thanks from "./Thanks.jsx";
import Contact from "./Contact.jsx";
import ApplicationForm from "./ApplicationForm.jsx";
import RecruitmentOfPartnerCompanies from "./RecruitmentOfPartnerCompanies.jsx";

import { useMediaQuery } from "react-responsive";

function App() {
  const isPC = useMediaQuery({ query: "(min-width: 1024px)" });

  const slug = document.querySelector("#root").dataset.slug;

  const Content = (slug) => {
    switch (slug) {
      case "flow-from-inquiry":
        return <FlowFromInquiry />;
      case "about-demolition-work":
        return <AboutDemolitionWork />;
      case "reason-for-choosing":
        return <ReasonForChoosing />;
      case "exterior":
        return <Exterior />;
      case "profile":
        return <Profile />;
      case "company":
        return <Company />;
      case "recruit":
        return <Recruit />;
      case "thanks":
        return <Thanks />;
      case "contact":
        return <Contact />;
      case "application-form":
        return <ApplicationForm />;
      case "recruitment-of-partner-companies":
        return <RecruitmentOfPartnerCompanies />;
    }
  };

  return (
    <>
      <Header />
      {isPC && <PageMenu />}
      <main>{Content(slug)}</main>
      <Footer />
    </>
  );
}

export default App;
